import { useQuery } from '@tanstack/react-query';
import { DEFAULT_STRAPI_STALE_TIME } from '@betterpool/strapi-client';

import { fetchGlossary } from '~/domains/services/nextApi.service';
import type { GlossaryProp } from '~/domains/cms/enums/glossary.enum';
import type { LeagueAlias } from '~/domains/common/enums/league-alias.enum';

const useGlossary = (league: LeagueAlias, prop: GlossaryProp, enabled = true) =>
  useQuery({
    queryKey: ['cms@glossary', league, prop],
    enabled: enabled && !!league && !!prop,
    queryFn: () => fetchGlossary(league, prop),
    staleTime: DEFAULT_STRAPI_STALE_TIME,
  });

export default useGlossary;
